(function () {
  var navButton = document.querySelector("[data-nav-toggle]");
  var bar = document.querySelector("[data-mobile-bar]");
  var sidebar = document.querySelector("[data-sidebar]");
  var scrim = document.querySelector("[data-scrim]");

  function setNav(open) {
    if (!bar || !sidebar) return;
    bar.classList.toggle("open", open);
    sidebar.classList.toggle("open", open);
    if (scrim) scrim.classList.toggle("open", open);
    if (navButton) navButton.setAttribute("aria-label", open ? "Close menu" : "Open menu");
  }

  if (navButton) navButton.addEventListener("click", function () { setNav(!bar.classList.contains("open")); });
  if (scrim) scrim.addEventListener("click", function () { setNav(false); });

  function money(cents) {
    var format = (window.theme && window.theme.moneyFormat) || "${{amount}}";
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
  }

  function drawer() { return document.querySelector("[data-cart-drawer]"); }

  function openCart() {
    var el = drawer();
    if (!el) return;
    el.classList.add("open");
    el.querySelector("[data-cart-close]") && el.querySelector("[data-cart-close]").focus();
  }

  function closeCart() {
    var el = drawer();
    if (el) el.classList.remove("open");
  }

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-cart-open]")) {
      event.preventDefault();
      openCart();
    }
    if (event.target.closest("[data-cart-close]")) closeCart();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeCart();
      closeZoom();
    }
  });

  async function refreshCart(initial) {
    var res = await fetch("/?section_id=cart-drawer");
    var html = await res.text();
    var wrap = document.createElement("div");
    wrap.innerHTML = html;
    var next = wrap.querySelector("[data-cart-drawer]");
    var current = drawer();
    if (next && current) {
      if (current.classList.contains("open")) next.classList.add("open");
      current.replaceWith(next);
    }
    var cart = await fetch("/cart.js").then(function (r) { return r.json(); });
    document.querySelectorAll("[data-cart-count]").forEach(function (node) { node.textContent = cart.item_count; var b = node.closest(".cart-text, .cart-link"); if (b) b.classList.toggle("cart-text--accent", cart.item_count > 0); });
    syncQty(cart);
    if (initial !== true) document.dispatchEvent(new CustomEvent("nb:cart-updated", { detail: cart }));
    return cart;
  }

  function syncQty(cart) {
    var map = {};
    (cart.items || []).forEach(function (item) { map[item.variant_id] = item.quantity; });
    document.querySelectorAll("[data-variant]").forEach(function (el) {
      var id = el.getAttribute("data-variant");
      var qty = map[id] || 0;
      var add = el.querySelector("[data-add]");
      var controls = el.querySelector("[data-qty]");
      var value = el.querySelector("[data-qty-value]");
      if (add) add.hidden = qty > 0;
      if (controls) controls.hidden = qty === 0;
      if (value) value.textContent = String(qty);
    });
  }

  async function post(url, body) {
    var res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error("Cart request failed");
    return res.json();
  }

  async function setQuantity(id, quantity) {
    if (quantity <= 0) {
      await post("/cart/change.js", { id: String(id), quantity: 0 });
    } else {
      var cart = await fetch("/cart.js").then(function (r) { return r.json(); });
      var exists = (cart.items || []).some(function (item) { return String(item.variant_id) === String(id) || String(item.key) === String(id); });
      if (!exists) await post("/cart/add.js", { items: [{ id: Number(id), quantity: quantity }] });
      else await post("/cart/change.js", { id: String(id), quantity: quantity });
    }
    var next = await refreshCart();
    return next;
  }

  document.addEventListener("click", function (event) {
    var add = event.target.closest("[data-add]");
    if (add) {
      event.preventDefault();
      setQuantity(add.getAttribute("data-add"), 1);
      return;
    }
    var delta = event.target.closest("[data-qty-delta]");
    if (delta) {
      event.preventDefault();
      var root = delta.closest("[data-variant]");
      var current = Number(root.querySelector("[data-qty-value]").textContent || "0");
      setQuantity(root.getAttribute("data-variant"), Math.max(0, current + Number(delta.getAttribute("data-qty-delta"))));
      return;
    }
    var line = event.target.closest("[data-line-delta]");
    if (line) {
      event.preventDefault();
      var row = line.closest("[data-line]");
      var qty = Number(row.getAttribute("data-line-qty") || "0");
      setQuantity(row.getAttribute("data-line"), Math.max(0, qty + Number(line.getAttribute("data-line-delta"))));
    }
  });

  document.addEventListener("submit", function (event) {
    var form = event.target.closest("[data-product-form]");
    if (!form) return;
    event.preventDefault();
    var id = form.querySelector("[name=id]").value;
    var qty = Number((form.querySelector("[name=quantity]") || {}).value || "1");
    post("/cart/add.js", { items: [{ id: Number(id), quantity: qty }] }).then(refreshCart).then(openCart);
  });

  document.addEventListener("change", function (event) {
    var option = event.target.closest("[data-option]");
    if (!option) return;
    var form = option.closest("[data-product-form]");
    var script = document.getElementById("product-variants");
    if (!form || !script) return;
    var variants = JSON.parse(script.textContent);
    var selected = {};
    form.querySelectorAll("[data-option]").forEach(function (input) {
      if (input.checked || input.tagName === "SELECT") selected[input.getAttribute("data-option")] = input.value;
    });
    var match = variants.find(function (variant) {
      return variant.options.every(function (value, index) { return selected["option" + (index + 1)] === value; });
    });
    if (!match) return;
    form.querySelector("[name=id]").value = match.id;
    var price = form.querySelector("[data-price]");
    if (price) {
      // 2026-11-01: compare-at markdown, same markup as sections/main-product.liquid.
      if (match.compare_at_price > match.price) {
        price.innerHTML = '<s class="price__was">' + money(match.compare_at_price) + '</s> ' + money(match.price) +
          ' <span class="price__off">' + Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price) + '% off</span>';
      } else {
        price.textContent = money(match.price);
      }
    }
    var button = form.querySelector("[data-submit]");
    if (button) {
      button.disabled = !match.available;
      button.textContent = match.available ? "Add to cart" : "Sold out";
    }
    var image = match.featured_image && (match.featured_image.src || match.featured_image);
    var frame = document.querySelector("[data-product-image]");
    if (frame && image) { frame.removeAttribute("srcset"); frame.removeAttribute("sizes"); frame.src = image; }
  });

  var zoom = 1;
  var pan = { x: 0, y: 0 };
  var drag = null;
  var dragged = false;

  function zoomImage() { return document.querySelector("[data-zoom-image]"); }

  function applyZoom() {
    var img = zoomImage();
    if (!img) return;
    img.style.transform = "translate(" + pan.x + "px, " + pan.y + "px) scale(" + zoom + ")";
    img.style.cursor = zoom > 1 ? "zoom-out" : "zoom-in";
  }

  function closeZoom() {
    var box = document.querySelector("[data-lightbox]");
    if (box) box.hidden = true;
    zoom = 1;
    pan = { x: 0, y: 0 };
    applyZoom();
  }

  document.addEventListener("click", function (event) {
    var open = event.target.closest("[data-zoom-open]");
    if (open) {
      var box = document.querySelector("[data-lightbox]");
      var img = zoomImage();
      if (!box || !img) return;
      img.src = open.getAttribute("data-zoom-open");
      box.hidden = false;
      zoom = 1;
      pan = { x: 0, y: 0 };
      applyZoom();
    }
    if (event.target.closest("[data-lightbox]") && !event.target.closest("[data-zoom-image]")) closeZoom();
  });

  document.addEventListener("click", function (event) {
    var img = event.target.closest("[data-zoom-image]");
    if (!img || dragged) { dragged = false; return; }
    event.stopPropagation();
    if (zoom > 1) { zoom = 1; pan = { x: 0, y: 0 }; applyZoom(); return; }
    var rect = img.getBoundingClientRect();
    var dx = event.clientX - (rect.left + rect.width / 2);
    var dy = event.clientY - (rect.top + rect.height / 2);
    zoom = 3.5;
    pan = { x: dx * (1 - zoom), y: dy * (1 - zoom) };
    applyZoom();
  });

  document.addEventListener("pointerdown", function (event) {
    var img = event.target.closest("[data-zoom-image]");
    if (!img) return;
    dragged = false;
    drag = { x: event.clientX, y: event.clientY, px: pan.x, py: pan.y };
  });
  document.addEventListener("pointermove", function (event) {
    if (!drag || zoom <= 1) return;
    var dx = event.clientX - drag.x;
    var dy = event.clientY - drag.y;
    if (Math.hypot(dx, dy) > 4) dragged = true;
    pan = { x: drag.px + dx, y: drag.py + dy };
    applyZoom();
  });
  document.addEventListener("pointerup", function () { drag = null; });

  var sort = document.querySelector("[data-sort]");
  if (sort) {
    sort.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sort.value);
      url.searchParams.delete("page");
      window.location = url.toString();
    });
  }

  document.addEventListener("click", function (event) {
    var thumb = event.target.closest("[data-thumb]");
    if (!thumb) return;
    var frame = document.querySelector("[data-product-image]");
    var opener = document.querySelector("[data-zoom-open]");
    if (frame) { frame.removeAttribute("srcset"); frame.removeAttribute("sizes"); frame.src = thumb.getAttribute("data-full"); }
    if (opener) opener.setAttribute("data-zoom-open", thumb.getAttribute("data-full"));
    document.querySelectorAll("[data-thumb]").forEach(function (button) {
      button.setAttribute("aria-pressed", button === thumb ? "true" : "false");
    });
  });

  document.addEventListener("input", function (event) {
    var input = event.target.closest("[data-proof-filter]");
    if (!input) return;
    var q = input.value.trim().toLowerCase();
    document.querySelectorAll(".proof-list li").forEach(function (item) {
      var title = (item.querySelector("h3") || {}).textContent || "";
      item.hidden = q.length > 0 && title.toLowerCase().indexOf(q) === -1;
    });
  });
  window.nbCart = { refresh: refreshCart, open: openCart }; /* 2026-11-01: used by the NB land set block below */
  refreshCart(true).catch(function () {});
})();

;/* NB masonry (round 10, 2026-10-15): row-order masonry for .gallery / .mosaic.
   Same technique as noahbradley.com/magic (nb-theme "nb-pack"): each item, in DOM order,
   is absolutely positioned into the currently shortest column. Column count and gap are
   read from the theme CSS (columns / column-gap per breakpoint), so breakpoints stay in CSS.
   If this script never runs, the plain CSS columns layout remains. */
(function () {
  var SEL = '.gallery, .mosaic';
  function items(grid) {
    return Array.prototype.filter.call(grid.children, function (el) {
      return (el.tagName === 'A' || el.tagName === 'BUTTON') && !el.hidden;
    });
  }
  function pack(grid) {
    var els = items(grid);
    if (!els.length) return;
    grid.classList.remove('nb-packed');           // read theme's own column settings
    var cs = getComputedStyle(grid);
    var cols = parseInt(cs.columnCount, 10) || 1;
    var gap = parseFloat(cs.columnGap) || 0;
    var rowGap = parseFloat(getComputedStyle(els[0]).marginBottom) || gap;
    var padL = parseFloat(cs.paddingLeft) || 0, padT = parseFloat(cs.paddingTop) || 0;
    var inner = grid.clientWidth - padL - (parseFloat(cs.paddingRight) || 0);
    if (cols < 2) {                                  // 1 column: plain flow is already in order
      els.forEach(function (el) { ['left', 'top', 'width'].forEach(function (p) { el.style.removeProperty(p); }); });
      grid.style.height = ''; return;
    }
    var w = (inner - gap * (cols - 1)) / cols, h = [];
    for (var i = 0; i < cols; i++) h.push(0);
    grid.classList.add('nb-packed');
    els.forEach(function (el) { el.style.width = w + 'px'; });
    var heights = els.map(function (el) { return el.getBoundingClientRect().height; }); // batch reads
    els.forEach(function (el, n) {
      var c = 0;
      for (var k = 1; k < cols; k++) if (h[k] < h[c] - 0.5) c = k;   // leftmost shortest
      el.style.left = (padL + c * (w + gap)) + 'px';
      el.style.top = (padT + h[c]) + 'px';
      h[c] += heights[n] + rowGap;
    });
    grid.style.height = (padT + Math.max.apply(null, h) - rowGap + (parseFloat(cs.paddingBottom) || 0)) + 'px';
  }
  var raf = 0;
  function all() { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { document.querySelectorAll(SEL).forEach(pack); }); }
  window.nbMasonry = all;
  all();
  document.addEventListener('nb:grid-reordered', all);
  window.addEventListener('resize', all);
  window.addEventListener('load', all);
  document.addEventListener('load', function (e) {          // lazy images finishing (fonts/captions/missing dims)
    if (e.target.tagName === 'IMG' && e.target.closest(SEL)) all();
  }, true);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);
})();

;/* NB cart page sync (2026-10-24): after any cart change, re-render the /cart section
   (lines, discounts, "You saved", free-shipping bar, upsell) without a reload.
   The drawer is already re-rendered by refreshCart(). */
(function () {
  var busy = 0;
  document.addEventListener("nb:cart-updated", function () {
    var page = document.querySelector("[data-cart-section]");
    if (!page) return;
    var wrap = page.closest("[id^='shopify-section-']");
    if (!wrap) return;
    var id = wrap.id.replace("shopify-section-", "");
    var ticket = ++busy;
    fetch(window.location.pathname + "?section_id=" + encodeURIComponent(id))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (ticket !== busy) return;
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var next = tmp.querySelector("[data-cart-section]");
        var current = document.querySelector("[data-cart-section]");
        if (next && current) current.replaceWith(next);
      })
      .catch(function () {});
  });
})();

;/* NB land set (2026-11-01): "Complete the set" for the five Battle for Zendikar basic land prints.
   Markup: snippets/land-set.liquid (product page, [data-landset]) and snippets/land-set-cart.liquid
   (cart drawer + /cart, rendered by cart-upsell). Any [data-landset-add] button adds lands in one /cart/add.js call,
   skipping variants already in the cart (no duplicate lines), then refreshes the drawer through window.nbCart
   (same refreshCart() as the theme's Add to cart, which also re-renders /cart via nb:cart-updated).
   From the product page the drawer opens afterwards, exactly like Add to cart. */
(function () {
  function money(cents) {
    var format = (window.theme && window.theme.moneyFormat) || "${{amount}}";
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
  }
  function sizeKey(t) { return String(t || "").replace(/″|"|\s/g, "").replace(/x/g, "×"); }
  function getCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
  function inCart(cart) {
    var m = {};
    (cart.items || []).forEach(function (i) { m[String(i.variant_id)] = true; });
    return m;
  }
  var lastCart = null;

  function block() { return document.querySelector("[data-landset]"); }
  function checked(root) { return root.querySelector("[data-landset-size]:checked"); }

  function render(root, cart) {
    if (!root) return;
    var radio = checked(root);
    if (!radio) { radio = root.querySelector("[data-landset-size]"); if (radio) radio.checked = true; }
    if (!radio) return;
    var full = root.querySelector("[data-landset-full]");
    var sale = root.querySelector("[data-landset-sale]");
    if (full) full.textContent = money(Number(radio.getAttribute("data-full")));
    if (sale) sale.textContent = money(Number(radio.getAttribute("data-sale")));
    var btn = root.querySelector("[data-landset-add]");
    if (!btn || btn.getAttribute("aria-busy") === "true") return;
    var ids = radio.getAttribute("data-ids").split(",");
    var total = Number(btn.getAttribute("data-landset-count")) || ids.length;
    var have = cart ? inCart(cart) : {};
    var missing = ids.filter(function (id) { return !have[id]; }).length;
    btn.disabled = missing === 0;
    if (missing === 0) btn.textContent = "All " + total + " are in your cart";
    else if (missing === total) btn.textContent = "Add all " + total + " to cart";
    else btn.textContent = "Add the other " + missing + " to cart";
  }

  function idsFor(btn) {
    var root = btn.closest("[data-landset]");
    if (root) { var r = checked(root); return r ? r.getAttribute("data-ids").split(",") : []; }
    return (btn.getAttribute("data-ids") || "").split(",").filter(Boolean);
  }

  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-landset-add]");
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute("aria-busy") === "true") return;
    var fromProduct = !!btn.closest("[data-landset]");
    var root = btn.closest("[data-landset]");
    var status = root && root.querySelector("[data-landset-status]");
    var ids = idsFor(btn);
    if (!ids.length) return;
    btn.setAttribute("aria-busy", "true");
    btn.disabled = true;
    if (status) status.textContent = "";
    getCart().then(function (cart) {
      var have = inCart(cart);
      var items = ids.filter(function (id) { return !have[id]; }).map(function (id) { return { id: Number(id), quantity: 1 }; });
      if (!items.length) return cart;
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); });
    }).then(function () {
      var api = window.nbCart;
      if (!api || !api.refresh) { window.location.href = "/cart"; return; }
      return api.refresh().then(function (cart) {
        btn.removeAttribute("aria-busy");
        lastCart = cart;
        render(block(), cart);
        if (fromProduct && api.open) api.open();
      });
    }).catch(function () {
      btn.removeAttribute("aria-busy");
      btn.disabled = false;
      if (status) status.textContent = "Couldn't add the set. Please try again.";
    });
  });

  document.addEventListener("change", function (event) {
    var root = block();
    if (!root) return;
    if (event.target.closest("[data-landset-size]")) { render(root, lastCart); return; }
    // Follow the size picked in the main product form.
    var opt = event.target.closest("[data-product-form] [data-option]");
    if (!opt) return;
    var key = sizeKey(opt.value);
    var match = Array.prototype.find.call(root.querySelectorAll("[data-landset-size]"), function (r) { return r.value === key; });
    if (match) { match.checked = true; render(root, lastCart); }
  });

  document.addEventListener("nb:cart-updated", function (event) { lastCart = event.detail || lastCart; render(block(), lastCart); });

  if (block()) {
    render(block(), null);
    getCart().then(function (cart) { lastCart = cart; render(block(), cart); }).catch(function () {});
  }
})();
